// extracted by mini-css-extract-plugin
export default {"SurveyRecordVerification":"SurveyRecordVerification_SurveyRecordVerification__7u5b7","RemoveVerification":"SurveyRecordVerification_RemoveVerification__156e1"};